import React, {useEffect, useRef, useState} from "react";
import {connect} from "react-redux";
import {useSearchParams} from "react-router-dom";
import {CButton, CCol, CForm, CFormLabel, CInputGroup, CInputGroupText, CRow} from "@coreui/react";
import * as o2Api from "../../../api/api";
import numeral from "numeral";
import {Loading} from "../../../components/common";
import {AgGridColumn, AgGridReact} from "ag-grid-react";
import * as formatter from "../../../config/formatter";
import {gridColumnSum} from "../../../config/common";
import {currencyFormatter} from "../../../config/formatter";
import locale from "antd/es/date-picker/locale/ko_KR";
import {DatePicker} from "antd";
import dayjs from "dayjs";
import * as saleMethod from "../../../api/method/saleMethod";


const PopupStockDetail = () => {
    const gridRef = useRef();
    const [params] = useSearchParams();
    const [loading, setLoading] = useState(false);
    const {RangePicker} = DatePicker;

    const [stockDetail, setStockDetail] = useState([
        {restProductCd: "", productNm: "", stockQty: 0}
    ]);
    const queryList = [...params];

    const [searchForm, setSearchForm] = useState({
        cmpCd: "", brandCd: "", storeCd: "",
        fromStockDt: dayjs(), toStockDt: dayjs()
    });

    const defaultColDef = {
        width: 100,
        resizable: true,
        sortable: true,
        filter: false,
        autoHeaderHeight: true
    };

    function stockFormatter(params) {
        //console.log("params:: ", params);
        if(params.data.stockCd === "10"){
            return "입고"
        } else if(params.data.stockCd === "20"){
            return "판매"
        } else if(params.data.stockCd === "29"){
            return "반출"
        }else if(params.data.stockCd === "" || params.data.stockCd === null){
            return "누적수량"
        }
    }
    let baseStockQty = 0;
    function baseStockQtyFormatter(params) {

        if(params.data.stockCd === "" || params.data.stockCd === null){
            baseStockQty = params.data.stockQty;
        } else if(params.data.stockCd === "10"){
            baseStockQty = baseStockQty + params.data.stockQty;
        } else if(params.data.stockCd === "20" || params.data.stockCd === "29"){
            baseStockQty = baseStockQty - params.data.stockQty;
        }
        console.log("baseStockQty:: ", baseStockQty);

        return baseStockQty;
    }

    const [columnDefs] = useState([
        {field: "seq", headerName: "No", maxWidth: 50, valueGetter: "node.rowIndex + 1", cellClass: "static-cell"},
        {field: "cmpCd", headerName: "회원사코드",  width: 130, hide:true},
        {field: "brandCd", headerName: "브랜드코드",  width: 130, hide:true},
        {field: "brandNm", headerName: "휴게소명",  width: 130, hide:true},
        {field: "restProductCd", headerName: "상품코드",  width: 100},
        {field: "productNm", headerName: "상품명",  width: 160},
        {field: "stockDt", headerName: "수불일자", width: 120,
            valueFormatter: (e) => {
                return formatter.timeFormatter(e, "YYYYMMDD", "YYYY-MM-DD")
            }
        },
        {field: "stockCd", headerName: "수불코드", width: 80, hide:true},
        {field: "stockNm", headerName: "수불구분", width: 120, valueFormatter: stockFormatter},
        {field: "stockQty", headerName: "수량", width: 80},
        {field: "baseStockQty", headerName: "누적수량", width: 80, valueFormatter: baseStockQtyFormatter}
    ]);

    const [totalRowData] = useState([
        {no: 0, storeNm: "합계"}
    ])

    useEffect(() => {
        const stockDt = queryList[4][1];

        const params = {
            cmpCd: queryList[0][1],
            brandCd: queryList[1][1],
            storeCd: queryList[2][1],
            productCd: queryList[3][1],
            stockDt: queryList[4][1],
            stockCd: '',
            fromStockDt : stockDt,
            toStockDt : stockDt
        };

        getProductStockDetail(params);
    }, []);

    const getProductStockDetail = (params) => {
        //setLoading(true);

        console.log("params :: " , params);

        o2Api.getProductStockDetail(params).then((result) => {
            const {responseBody, responseCode, responseMessage} = result.data;
            console.log("### response :: ", responseBody);
            if (responseCode === "200") {
                setLoading(false);
            console.log("responseBody:: ", responseBody);
               setStockDetail(responseBody);

            } else {
                setLoading(false);
            }
        });
    }

    const search = () => {
        const {fromStockDt, toStockDt} = searchForm;

        const params = {
            cmpCd: queryList[0][1],
            brandCd: queryList[1][1],
            storeCd: queryList[2][1],
            productCd: queryList[3][1],
            stockDt: queryList[4][1],
            fromStockDt : searchForm.fromStockDt.format("YYYYMMDD"),
            toStockDt : searchForm.toStockDt.format("YYYYMMDD"),
        };
        console.log(">>> 조회 시 params :: ", params);

        setLoading(true);
        o2Api.getProductStockDetail(params).then((result) => {
            const {responseBody, responseCode, responseMessage} = result.data;
            console.log("result : ", responseBody);
            if (responseCode === "200") {
                // 성공
                setStockDetail(responseBody);
            }
            setLoading(false);
        });

    } //End search()

    return (
        <>
            <div style={{padding: 16}}>
                {loading ? <Loading/> : null}
                <div style={{borderRadius: 5, padding: 10, marginBottom: 10, background: "#13319b"}}>
                    <span
                        style={{
                            color: 'white',
                            fontWeight: 600
                        }}>

                        상품 : {stockDetail[0].restProductCd} ({stockDetail[0].productNm})
                    </span>
                </div>

                {/* =========================================   ================================================*/}
                <div className={"row row-cols-lg-auto g-1 m-0 align-items-center"}>
                    <CCol sm={12}>
                        <CInputGroup size={"sm"}>
                            <CInputGroupText style={{width: 80}}>조회일자</CInputGroupText>
                            <CInputGroupText style={{background: "white", height: 35}}>
                                <RangePicker bordered={false}
                                             separator={"~"}
                                             placeholder={""}
                                             locale={locale}
                                             value={[searchForm.fromStockDt, searchForm.toStockDt]}
                                             onChange={(dayjs, dateString) => {
                                                 setSearchForm((state) => ({
                                                     ...state, fromStockDt: dayjs[0], toStockDt: dayjs[1]
                                                 }));
                                             }}/>
                            </CInputGroupText>
                        </CInputGroup>

                        <div className={"d-grid"}>
                            <CButton style={{minWidth: 50, height: 35, marginTop : 5}} size={"sm"} color={"primary"} onClick={search}>조회</CButton>
                        </div>
                    </CCol>

                </div>


                <div className="ag-theme-alpine" style={{width: "100%", height: 700, marginTop: 10}}>
                    <AgGridReact
                        ref={gridRef}
                        rowSelection={"single"}
                        headerHeight={30}
                        rowHeight={30}
                        rowHeight={30}
                        rowHeight={30}
                        rowData={stockDetail}
                        animateRows={true}
                        defaultColDef={defaultColDef}
                        columnDefs={columnDefs}>
                    </AgGridReact>
                </div>
            </div>
        </>
    )
}

export default connect(null, null)(PopupStockDetail);
